<template>
  <div>
    <AppWithLoading :fetch="fetch" :key="id" v-slot:default="{loader}">
      <VacancyListsDetail v-if="item" :value="item">
        <template #head>
          <h1 class="qr-title">
            {{ $t('h1') }}
          </h1>
        </template>
        <template v-slot:actions="{item, validate}">
          <div class="mb-4">
            <VBtn
              @click="loader(() =>validate() && update(item))"
              class="mr-2"
              color="success"
            >
              {{ $t('save') }}
            </VBtn>
            <VBtn @click="toList" outlined color="#EEEEEE">
              <span style="color: #000000">{{ $t('cancel') }}</span>
            </VBtn>
          </div>
        </template>
      </VacancyListsDetail>
    </AppWithLoading>
  </div>
</template>

<script>
import VacancyListsDetail from '@/components/VacancyLists/VacanciesListDetail';
import { computed, toRefs } from '@vue/composition-api';
import useVacanciesList from '@/compositions/useVacanciesList';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'VacanciesListDetailPage',
  components: { AppWithLoading, VacancyListsDetail },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props, { root: { $router } }) {
    const { id } = toRefs(props);
    const { fetchById, findById, update } = useVacanciesList();
    const item = computed(() => findById(id.value));

    function fetch() {
      return fetchById(id.value);
    }

    function toList() {
      $router.push({ name: 'qr-list' });
    }

    return {
      fetch,
      item,
      update: async (payload) => {
        await update(id.value, payload);
        await fetch();
        toList();
      },
      toList,
    };
  },
};
</script>

<style scoped>
.qr-title {
  font-size: 1.5rem;
  line-height: 1.25;
  font-weight: 400;
  color: #212121;
  padding-top: 1.75rem;
  margin-bottom: 1.375rem;
}
</style>

<i18n lang="yml" locale="ru">
  save: Сохранить
  cancel: Отмена
  h1: Изменить страницу
</i18n>
<i18n lang="yml" locale="en">
  save: Save
  cancel: Cancel
  h1: Edit page
</i18n>
